var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"color":_vm.bg}},[(!_vm.showBadge)?_c('v-img',{attrs:{"src":_vm.hubatar},on:{"error":_vm.onAvatarError}}):_c('span',{style:({ fontSize:(_vm.size/3)+'px' })},[_vm._v(" "+_vm._s(_vm.initials)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }